import EditIcon from "@mui/icons-material/Edit";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { useSettingsListQuery } from "api/settings/settings.mutation";
import { Table } from "components/Table";
import { useState } from "react";
import { EditSettingsModal } from "./components/editSettingsModel";
import classes from "./style.module.scss";

const Settings = () => {
  const [updateSettingsModal, setUpdateSettingsModal] = useState({
    open: false,
  });

  const settingsQuery = useSettingsListQuery();
  const tableData = settingsQuery.data ?? [];

  const handleCloseUpdateSettingsModal = () => {
    setUpdateSettingsModal({
      open: false,
    });
  };

  const columns = [
    {
      field: "fa_name",
      headerName: "نام",
      minWidth: 220,
      flex: 1,
      sortable: false,
      resizable: false,
    },
    {
      field: "value",
      headerName: "محتوا",
      minWidth: 350,
      flex: 1,
      sortable: false,
      resizable: false,
      renderCell: ({ row }) => {
        if (
          [
            "start_bachelor_register_date",
            "end_bachelor_register_date",
            "start_register_date",
            "end_register_date",
            "start_phd_register_date",
            "end_phd_register_date",
          ].includes(row?.field)
        ) {
          const input = new Date(row?.value);
          input.setDate(input.getDate() + 1);
          return input.toLocaleDateString("fa-IR");
        } else {
          return row?.value;
        }
      },
    },
  ];

  return (
    <>
      <div className={classes.mainDiv}>
        <div className={classes.toolBar}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4} />
            <Grid item xs={0} md={4} />
            <Grid item xs={12} md={4}>
              <div className={classes.manageBar}>
                <Tooltip title="ویرایش تنظیمات">
                  <IconButton
                    onClick={() => setUpdateSettingsModal({ open: true })}
                    color="primary"
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </Grid>
          </Grid>
        </div>
        <Table
          rows={tableData}
          columns={columns}
          loading={settingsQuery.isFetching}
          hiddenPagination
          className={classes.tableContainer}
        />
      </div>
      <EditSettingsModal
        open={updateSettingsModal.open}
        onClose={handleCloseUpdateSettingsModal}
        defaultData={{
          fa_terms: tableData.find((item) => item.field === "fa_terms")?.value,
          en_terms: tableData.find((item) => item.field === "en_terms")?.value,
          ar_terms: tableData.find((item) => item.field === "ar_terms")?.value,
          start_bachelor_register_date: tableData.find(
            (item) => item.field === "start_bachelor_register_date"
          )?.value,
          end_bachelor_register_date: tableData.find(
            (item) => item.field === "end_bachelor_register_date"
          )?.value,
          start_register_date: tableData.find((item) => item.field === "start_register_date")
            ?.value,
          end_register_date: tableData.find((item) => item.field === "end_register_date")?.value,
          start_phd_register_date: tableData.find(
            (item) => item.field === "start_phd_register_date"
          )?.value,
          end_phd_register_date: tableData.find((item) => item.field === "end_phd_register_date")
            ?.value,
        }}
      />
    </>
  );
};

export default Settings;
